// extracted by mini-css-extract-plugin
export default {"icon":"tHlA","title":"KGy5","list":"alAP","article":"YWtA"};